import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import CustomErrorPage from "./CustomErrorPage";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <CustomErrorPage
      title="Page Not Found, But Our Doughnuts Are!"
      message={`The page "${location.pathname}" doesn't exist, but your perfect celebration package does`}
      showRetry={false}
    />
  );
};

export default NotFound;
